/* eslint-disable react/jsx-no-undef */
import React, { useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import TopLogo from '../../components/layout/TopLogo';
import { useLiff } from "react-liff";
import dayjs from "dayjs";
import SecondaryButton from "../../components/button/SecondaryButton";
import Stack from "@mui/material/Stack";
import { useDispatch } from 'react-redux';
import { SearchPrizeById } from "../../services/Prize";
import iconCopy from '../../assets/images/icon/copy.svg';
import iconLink from '../../assets/images/icon/foreign 1.svg';
import useWindowDimensions from "../../functions/getScreen";
import prizeDefault from '../../assets/images/haier-prize-default.png';
import Alert from '@mui/material/Alert';
import Collapse from '@mui/material/Collapse';
import { styled } from '@mui/material/styles';
import { CopyToClipboard } from 'react-copy-to-clipboard';


export default function PrizeHistory() {

    const StyledAlert = styled(Alert)(({ theme }) => ({
        backgroundColor: '#005AAA', // your custom color
    }));

    const { liff } = useLiff();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { state } = useLocation();
    const tracking = useRef(null);
    const [prizeDetail, setPrizeDetail] = React.useState(null);
    const { height } = useWindowDimensions();
    const [open, setOpen] = React.useState(false);


    React.useEffect(() => {
        getSearchPrizeById();
    }, []);

    async function getSearchPrizeById() {
        return await SearchPrizeById(state)
            .then(async (response) => {
                if (+response.data.resultCode === 20000) {
                    setPrizeDetail(response.data.body)
                }
            })
            .catch((error) => {
                console.log(error);
            });
    }


    return (
        <>

            <TopLogo />
            {prizeDetail &&

                <div className="overflow-y-auto  bg-white" style={{ height: `${height - 156}px` }}>
                    {/* <InfiniteScroll
                        loadMore={fetchItems}
                        hasMore={isLoading}
                        loader={loader}
                    > */}
                    <div id="section1" className="mb-[20px]">
                        {prizeDetail.picture ? (
                            <img
                                className="mx-auto mt-[10px] w-full"
                                src={prizeDetail.picture}
                                alt="logo"
                            />
                        ) : (
                            <img
                                className="mx-auto mt-[10px] w-full"
                                src={prizeDefault}
                                alt="logo"
                            />
                        )
                        }

                        <div className="px-[30px]">

                            <p className="mt-[20px] text-blue text-[24px]">{prizeDetail.name}</p>

                            <p className="text-blue text-[20px] w-[82.5px]">หมายเลขพัสดุ:</p>
                            <div className="flex gap-[5px]">

                                {prizeDetail.tracking &&
                                    <>
                                        <img
                                            src={prizeDetail.tracking.picture}
                                            alt="logo"
                                            style={{ height: "25px" }}
                                            onClick={() => liff.openWindow({ url: prizeDetail.tracking.link, external: false })}
                                        />
                                        <img
                                            onClick={() => liff.openWindow({ url: prizeDetail.tracking.link, external: false })}
                                            className="mt-[5px] ml-[5px]"
                                            src={iconLink}
                                            alt="logo"
                                            style={{ width: "14px", height: "14px" }}
                                        />
                                        <p ref={tracking} className="text-blue text-[20px] leading-[20px] mt-[3px]">{prizeDetail.tracking.no}</p>
                                        {/* <img

                                            className="mt-[1px]"
                                            src={iconCopy}
                                            alt="logo"
                                            style={{ width: "14px", height: "14px" }}
                                        /> */}
                                        <CopyToClipboard text={prizeDetail.tracking.no}>
                                            <div className="w-[60px] h-[25px] bg-lightBlue2" style={{ borderRadius: '5px' }}
                                                onClick={() => {
                                                    // navigator.clipboard.writeText(prizeDetail.tracking.no)
                                                    setOpen(true)
                                                    setTimeout(() => {
                                                        setOpen(false)
                                                    }, 3000);
                                                }
                                                }>

                                                <div className="flex gap-[5px] mx-auto w-fit">
                                                    <img
                                                        className="mt-[5px]"
                                                        src={iconCopy}
                                                        alt="logo"
                                                        style={{ height: '14px' }}
                                                    />
                                                    <p className="text-white text-[15px] mt-[1px]">Copy</p>
                                                </div>
                                            </div>
                                        </CopyToClipboard>
                                    </>
                                }
                            </div>


                            <p className="text-[12px] mt-[10px]" style={{ color: "rgba(109, 110, 113, 1)" }}>สามารถตรวจสอบสถานะการจัดส่งได้ โดยการกดที่หมายเลขพัสดุ</p>


                            <hr className="border-b-1px border-lightGray w-full mt-[10px] mb-[20px]" />

                            <div style={{ color: "rgba(57, 57, 57, 1)" }}>
                                <p className="text-[24px] font-bold">รายละเอียด</p>
                                <div className="mt-[5px] flex justify-between items-start">
                                    <p className="text-[16px] leading-[24px]">
                                        รหัสรางวัล:
                                    </p>
                                    <p className="text-[16px]">{prizeDetail.code}</p>
                                </div>
                                <div className="flex justify-between items-start">
                                    <p className="text-[16px] leading-[24px]">
                                        วันที่/เวลาแลกของรางวัล:
                                    </p>
                                    <p className="text-[16px]">{dayjs(prizeDetail.getRewardDate, 'YYYY-MM-DD HH:mm:ss').add(7, 'hours').format('DD/MM/YYYY HH:mm:ss')}น.</p>
                                </div>
                                <div className="">
                                    <p className="text-[16px] leading-[24px]">
                                        สถานที่จัดส่ง:
                                    </p>
                                    <p className="text-[16px]">{prizeDetail.fullDeAddress}</p>
                                </div>
                            </div>

                        </div>

                        <br></br>
                    </div>

                </div >
            }
            <div className="bg-white h-[100px] pt-[25px]">
                <Stack
                    spacing={2}
                    direction="row"
                    alignItems="center"
                    justifyContent="center"
                >
                    <SecondaryButton variant="outlined" className="w-[80%]" onClick={() => navigate(-1)}>
                        ย้อนกลับ
                    </SecondaryButton>

                </Stack>
            </div>
            <Collapse in={open}>
                {/* <Alert variant="filled" icon={false} className="w-full mx-auto bg-lightBlue2" style={{ position: 'fixed', bottom: 0 }}>
                    คัดลอกลงคลิปบอร์ดเรียบร้อยแล้ว
                </Alert> */}
                <StyledAlert variant="filled" icon={false} className="w-full mx-auto" style={{ position: 'fixed', top: 0 }}
                >
                    คัดลอกลงคลิปบอร์ดเรียบร้อยแล้ว
                </StyledAlert>
            </Collapse>


        </>
    );
}
